import { backendApi } from "../dynamicBAseQuery";

export const loginApi = backendApi.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        validateLogin: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `validate`,
                body: {...args}
            })
        }),

        forgetPassword: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `forgetPassword`,
                body: {...args}
            })
        }),

        PasswordByToken: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `changePasswordByToken`,
                body: {...args}
            })
        }),

        forgotOtpPassword: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `forgotOtpPassword`,
                body: {...args}
            })
        }),
        
        validateOTPAndUpdatePassword: builder.mutation({
            query: (args) => ({
                method: "POST",
                url: `validateOTPAndUpdatePassword`,
                body: {...args}
            })
        }),

    })
})

export const {
    useValidateLoginMutation,
    useForgetPasswordMutation,
    usePasswordByTokenMutation,
    useForgotOtpPasswordMutation,
    useValidateOTPAndUpdatePasswordMutation
} = loginApi